import * as React from 'react';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {NavLink} from 'react-router-dom';
import {BellOutlined, LogoutOutlined} from '@ant-design/icons';
import {Button, Divider, Drawer, Menu} from 'antd';
import {PRMGAvatar} from 'components/PRMGAvatar';
import {observer} from 'mobx-react-lite';
import {AppRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';
import {getNavigationItem, sidebarNavigation} from './navigation';

export interface MobileMenuProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = observer(({open, setOpen}) => {
  const {t} = useTranslation();

  const navItems = useMemo(
    () =>
      sidebarNavigation.map(({title, url, Icon}) =>
        getNavigationItem(
          <NavLink to={url}>{title}</NavLink>,
          url,
          <Icon />,
          url === AppRoutePaths.garages.url
            ? appState.garages.map((garage) =>
                getNavigationItem(<NavLink to={url + `/${garage.id}`}>{garage.name}</NavLink>, String(garage.id))
              )
            : undefined
        )
      ),
    []
  );

  return (
    <Drawer
      title="Menu"
      placement="left"
      onClose={() => setOpen(false)}
      open={open}
      bodyStyle={{padding: 0, paddingTop: '1rem'}}
    >
      <Menu mode="inline" className="br-0" items={navItems} />
      <Divider />
      <Menu
        mode="inline"
        className="br-0"
        items={[
          getNavigationItem(
            <NavLink to="" className="flex items-center gap-2">
              <PRMGAvatar />
              {t('User Settings')}
            </NavLink>,
            'user-settings'
          ),
        ]}
      />
      <Divider />
      <Menu
        mode="inline"
        className="br-0"
        items={[
          getNavigationItem(
            <NavLink to="" className="flex items-center gap-2">
              <BellOutlined />
              {t('Notifications')}
            </NavLink>,
            'notifications'
          ),
          getNavigationItem(
            <Button type="text" icon={<LogoutOutlined />} className="p-0" onClick={() => appState.logout()}>
              {t('Logout')}
            </Button>,
            'logout'
          ),
        ]}
      />
    </Drawer>
  );
});
